<template>
    <div class="set-component">
        <div class="set-header">消息通知</div>
        <div class="set-body">
            <el-form label-width="140px" size="small">
                <el-form-item label="新消息通知">
                    <el-switch v-model="notice.newMessage" :active-value="1" :inactive-value="0" />
                </el-form-item>
                <el-form-item label="评论通知">
                    <el-switch v-model="notice.comment" :active-value="1" :inactive-value="0" />
                </el-form-item>
                <el-form-item label="点赞通知">
                    <el-switch v-model="notice.like" :active-value="1" :inactive-value="0" />
                </el-form-item>
                <el-form-item label="系统通知">
                    <el-switch v-model="notice.system" :active-value="1" :inactive-value="0" />
                </el-form-item>
                <el-form-item label="声音提醒">
                    <el-switch v-model="notice.sound" :active-value="1" :inactive-value="0" />
                </el-form-item>
                <el-form-item label="震动提醒">
                    <el-switch v-model="notice.vibrate" :active-value="1" :inactive-value="0" />
                </el-form-item>
            </el-form>
            <el-button type="primary" size="small" :loading="saveLoading" @click="handleSave">保存</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MessageNotice',
    data() {
        return {
            notice: {
                newMessage: 1,
                comment: 1,
                like: 1,
                system: 1,
                sound: 1,
                vibrate: 1
            },
            saveLoading: false
        };
    },
    mounted() {
        this.loadNoticeSetting();
    },
    methods: {
        getUserId() {
            const user = JSON.parse(localStorage.getItem('userInfo'));
            return user ? (user.userId || user.id) : null;
        },
        async loadNoticeSetting() {
            try {
                const userId = this.getUserId();
                if (userId) {
                    const res = await this.$axios.get('/api/user/notice/get', { params: { userId } });
                    if (res.data && res.data.code === 200) {
                        const data = res.data.data;
                        if (data) {
                            this.notice = {
                                newMessage: data.newMessage ?? 1,
                                comment: data.comment ?? 1,
                                like: data.like ?? 1,
                                system: data.system ?? 1,
                                sound: data.sound ?? 1,
                                vibrate: data.vibrate ?? 1
                            };
                        }
                    }
                }
            } catch (e) {
                console.error('获取通知设置失败', e);
            }
        },
        async handleSave() {
            this.saveLoading = true;
            try {
                const userId = this.getUserId();
                const res = await this.$axios.post('/api/user/notice/update', {
                    userId,
                    newMessage: this.notice.newMessage,
                    comment: this.notice.comment,
                    like: this.notice.like,
                    system: this.notice.system,
                    sound: this.notice.sound,
                    vibrate: this.notice.vibrate
                });
                if (res.data && res.data.code === 200) {
                    this.$message.success('保存成功');
                } else {
                    this.$message.error('保存失败：' + (res.data.message || '未知错误'));
                }
            } catch (e) {
                this.$message.error('保存失败：' + (e.message || '未知错误'));
            } finally {
                this.saveLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.set-component { background: var(--card-background); border-radius: 12px; border: 1px solid var(--border-color-lighter); }
.set-header { padding: 18px 24px; font-size: 16px; font-weight: 600; color: var(--text-color); border-bottom: 1px solid var(--border-color-lighter); }
.set-body { padding: 24px; }
</style>
